module.exports = __webpack_public_path__ + "img/icon_gerenciamento_de_comunicacoes.124a6025.png";